import cx from "classnames";
import { forwardRef } from "react";

import FileUploadDragDropArea from "./DragDropArea";
import FileUploadFileItem from "./FileItem";

type FileUploadProps = {
  ariaLabel?: string;
  name?: string;
  caption?: string;
  className?: string;
  textAlign?: "left" | "center";
  dragBoxClassName?: string;
  fileListClassName?: string;
  file: File | null;
  loading?: boolean;
  onChange: (file: File | null) => void;
};

const FileUpload = forwardRef(function FileUpload(
  {
    onChange,
    ariaLabel,
    file,
    name,
    caption,
    className,
    textAlign,
    dragBoxClassName,
    fileListClassName,
    loading,
  }: FileUploadProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  if (file) {
    return (
      <FileUploadFileItem
        fileName={file.name}
        className={cx(className, fileListClassName)}
        loading={loading}
        onDelete={() => onChange(null)}
      />
    );
  }

  return (
    <FileUploadDragDropArea
      ref={ref}
      ariaLabel={ariaLabel}
      name={name}
      caption={caption}
      textAlign={textAlign}
      className={cx(className, dragBoxClassName)}
      onChange={onChange}
    />
  );
});

FileUpload.displayName = "DS.FileUpload";

export default FileUpload;
